import React, { useEffect } from 'react';
import ScrollToTop from '../../../shared/utils/scrollToTop';
import { ComponentLoader, HorizontalRule, InPageAlert, SectionPage } from '@snsw/react-component-library';
import { useDispatch, useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { saveApplication } from 'shared/redux/applicationSlice';
import { getFees } from 'plantItemNew/redux/slices/feesSlice';
import FeeSummary from 'shared/components/feeSummary/FeeSummary';
import { initIndividualPayment } from 'plantItemNew/redux/slices/paymentSlice';
import { useNavigate } from 'react-router-dom';
import { PasswordlessContinueSaveExitButtons } from 'shared/components/formNavigationButtons/PasswordlessContinueSaveExitButtons';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';

export const Fees = (props) => {
  ScrollToTop();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fees = useSelector((state) => state.fees);
  const payment = useSelector((state) => state.payment);
  const { paymentReference, paymentRedirectUrl, paymentLoading } = payment;

  const formatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  });

  useEffect(() => {
    // TODO: Don't pass the duration from front end as it's fixed.
    dispatch(getFees('1 Year'));
  }, [dispatch]);

  const onContinueClick = () => {
    dispatch(initIndividualPayment('1 Year'));
  };

  useEffect(() => {
    if (paymentReference && paymentRedirectUrl) {
      window.location.href = `${paymentRedirectUrl}${paymentReference}`;
    }
  }, [paymentReference, paymentRedirectUrl]);

  const onSaveExitClick = () => {
    dispatch(saveApplication(true));
  };

  const onBackClick = () => {
    navigate(PagePath.declaration);
  };

  const mapFeeComponents = (data = {}) => {
    const feeComponents = [
      {
        feeName: `First Item (${formatter.format(data.baseFee)})`,
        value: data.baseFee,
        quantity: 1,
      },
    ];

    if (data.additionalItemsCount) {
      const feePerItem = formatter.format(data.feePerAdditionalItem);

      feeComponents.push({
        feeName: `Additional items (${feePerItem} each)`,
        value: data.feePerAdditionalItem * data.additionalItemsCount,
        quantity: data.additionalItemsCount,
      });
    }

    return feeComponents;
  };

  return (
    <SectionPage>
      <InPageAlert
        variant="info"
        title="You’ll be taken to a secure platform provided by Service NSW to complete your payment and submit your application."
        headingLevel="h4"
      />

      <div style={{ marginTop: 32, marginBottom: 64 }}>
        <FeeSummary
          isLoading={fees.status === 'loading'}
          title="Fee breakdown"
          feeDesctiption="Plant item registration fee (1 year)"
          totalFeeAmount={fees.data?.totalFeeAmount}
          feeComponents={fees?.data && mapFeeComponents(fees.data)}
        />
      </div>

      <HorizontalRule />

      <PasswordlessContinueSaveExitButtons
        onContinueClick={onContinueClick}
        onPreSaving={onSaveExitClick}
        onBackClick={onBackClick}
        licenceType={PlantItemConstants.licenceType}
      />

      {paymentLoading && <ComponentLoader />}
    </SectionPage>
  );
};
